import React from 'react';
import { Page } from '../../../../../shared/Components/Page';
import {ImportarContainer} from './Screen';

export const ImportarFicheroView = () =>{

    return (
        <Page title={'Gestion DNs - Importar'} scrollBody>{<ImportarContainer/>}</Page>
    )
}